import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { toIsoDate, toIsoDateTime } from "utils/apiDates";

import {
  exportWorkspacesFailed,
  exportWorkspacesFinished,
  exportWorkspacesStarted,
} from "./cloudUsageSlice";

const BASE_URL = "/api/cloud-usage";

const buildParams = (filters, { detail, sortBy, sortDir } = {}) => {
  const params = { ...filters };
  delete params.q;
  if (detail) {
    params.detail = detail;
  }
  if (sortBy) {
    params.sortBy = sortBy;
  }
  if (sortDir) {
    params.sortDir = sortDir;
  }
  return params;
};

const normalizeCoverage = (coverage) => ({
  ...coverage,
  from: toIsoDate(coverage.from),
  to: toIsoDate(coverage.to),
});

const normalizeRow = (row) => ({ ...row, lastActive: toIsoDateTime(row.lastActive) });

export const fetchAllWorkspaces = createAsyncThunk(
  "cloudUsage/fetchAllWorkspaces",
  async ({ detail } = {}, { getState }) => {
    const { filters } = getState().cloudUsage;
    const { data } = await localhost.get(`${BASE_URL}/workspaces`, {
      params: buildParams(filters, { detail }),
    });
    if (!data) {
      return data;
    }
    return {
      ...data,
      ...(data.coverage ? { coverage: normalizeCoverage(data.coverage) } : {}),
      ...(Array.isArray(data.rows) ? { rows: data.rows.map(normalizeRow) } : {}),
    };
  }
);

export const exportWorkspacesThunk =
  ({ detail, sortBy, sortDir } = {}) =>
  async (dispatch, getState) => {
    dispatch(exportWorkspacesStarted());
    const { filters } = getState().cloudUsage;
    try {
      const response = await localhost.get(`${BASE_URL}/workspaces/export`, {
        params: buildParams(filters, { detail, sortBy, sortDir }),
        responseType: "blob",
      });
      dispatch(exportWorkspacesFinished());
      return new Blob([response.data]);
    } catch (err) {
      dispatch(showErrorModal(err));
      dispatch(exportWorkspacesFailed(err.message));
      return null;
    }
  };
